import { DemographicKind } from 'api/dto/Demographic.dto';

export type ClassificationDateDto = {
  id?: number;
  value?: string;
  demography: number;
  demographyKind?: number;
};

export type ClassificationDateModel = {
  id?: number;
  value?: string;
  demographyId?: number;
  demographyKind?: DemographicKind;
};

export function mapClassificationDateModelToDto(
  model: ClassificationDateModel,
): ClassificationDateDto {
  return {
    id: model.id,
    value: model.value,
    demography: model.demographyId,
  };
}

export function mapClassificationDateDtoToModel(
  dto: ClassificationDateDto,
): ClassificationDateModel {
  return {
    id: dto.id,
    value: dto.value,
    demographyKind: dto.demographyKind,

    // Fields different from API Entry
    demographyId: dto.demography,
  };
}
